import { Children, ReactNode, useRef } from 'react';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import CarouselArrows from './components/CarouselArrows/CarouselArrows';

import styles from './Carousel.module.css';

type CarouselProps = {
    children: ReactNode;
    loop?: boolean;
    slidesPerView?: number;
    overlays?: ReactNode;
};

const Carousel = ({
    children,
    overlays,
    loop = true,
    slidesPerView = 1,
}: CarouselProps) => {
    const swiperRef = useRef<SwiperCore>();
    const hasMoreThanOneSlide = Children.count(children) > 1;

    return (
        <div className={styles.Root}>
            <div className={styles.Slides}>
                {hasMoreThanOneSlide ? (
                    <Swiper
                        loop={loop}
                        slidesPerView={slidesPerView}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                    >
                        {Children.map(children, (child, index) => (
                            <SwiperSlide key={index}>{child}</SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    children
                )}
            </div>

            {overlays && <div className={styles.Overlays}>{overlays}</div>}

            {hasMoreThanOneSlide && (
                <div className={styles.Arrows}>
                    <CarouselArrows
                        onLeft={() =>
                            swiperRef.current && swiperRef.current.slidePrev()
                        }
                        onRight={() =>
                            swiperRef.current && swiperRef.current.slideNext()
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default Carousel;
